import { render, staticRenderFns } from "./HedgePolicy.vue?vue&type=template&id=13514530&"
import script from "./HedgePolicy.vue?vue&type=script&lang=js&"
export * from "./HedgePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports